import { IWorkflowNode } from "motw_core/Entity/IWorkflowNode";
import * as React from "react";
import * as toastr from "toastr";
import { IRootNodeFormState } from "source/app/presentation/MainPanel/Workflows/RootNodeName/Helpers/IRootNodeFormState";

export function PrepareRootNodeNameForEdit(
    rootNode: IWorkflowNode,
    parentNode: IWorkflowNode,
    setState: React.Dispatch<React.SetStateAction<IRootNodeFormState>>,
    state: IRootNodeFormState
) {
    const canEdit = rootNode.id !== 0; //&& !parentNode?.viewchronological;

    if (canEdit) {
        setState({ ...state, showEditControls: true });
    }

    if (rootNode.id === 0) {
        toastr.warning(`Home node cannot be edited`);
    }

    // if (parentNode?.viewchronological) {
    //     toastr.warning(
    //         `Immediate child of a chronological node cannot be edited.`
    //     );
    // }

    return;
}
